import React from 'react';
import { CollapsableButton, CollapsableContainer } from '../styled/common';
import { SmallText } from 'ds/components/typography';
import { Spring, animated } from 'react-spring';
import ArrowDown from 'assets/svg/arrow-down.svg';
import ArrowUp from 'assets/svg/arrow-up.svg';

interface CollapsableProps {
  collapsedHeight: number;
  buttonLabel?: string;
  isCollapsed: boolean;
  onClick?(): void;
}

export const Collapsable: React.FunctionComponent<CollapsableProps> = ({
  children,
  collapsedHeight,
  onClick,
  isCollapsed,
  buttonLabel,
}) => (
  <CollapsableContainer>
    <Spring
      native
      config={{ tension: 2000, friction: 100, precision: 1 }}
      from={{ height: isCollapsed ? 'auto' : collapsedHeight }}
      to={{ height: isCollapsed ? collapsedHeight : 'auto' }}
    >
      {props => (
        <animated.div className="collapsible" style={props}>
          {children}
        </animated.div>
      )}
    </Spring>
    {onClick && buttonLabel ? (
      <CollapsableButton data-auto="collapsableButton" isCollapsed={isCollapsed} onClick={onClick}>
        <SmallText weight="bold" style={{ cursor: 'pointer' }}>{buttonLabel}</SmallText>
        {isCollapsed ? <ArrowDown width={20} height={20}/> : <ArrowUp width={20} height={20} />}
      </CollapsableButton>
    ) : null}
  </CollapsableContainer>
);

